// extracted by mini-css-extract-plugin
export default {"forgotPasswordContainer":"ForgotPassword_forgotPasswordContainer__1jbkF","message":"ForgotPassword_message__rN-5J"};